export default __webpack_public_path__ + "static/6-c7402ac7d07d5af3551e453e65a7618f.jpg";